import React, { useEffect, useRef, useState, useContext } from 'react';

import {
    ArrowDropDown,
    ArrowLeft,
    ArrowRight,
} from '@mui/icons-material';
import AddBoxIcon from '@mui/icons-material/AddBox';
import BusinessIcon from '@mui/icons-material/Business';
import IndeterminateCheckBoxIcon from '@mui/icons-material/IndeterminateCheckBox';
import RoomIcon from '@mui/icons-material/Room';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import {
    TreeItem,
    TreeView
} from '@mui/lab';
import {
    Box, Button, Checkbox, CircularProgress, Collapse, Grid, Grow,
    Hidden,
    IconButton, LinearProgress, Link, Paper,
    Tooltip,
    Typography,
    useMediaQuery, useTheme,
} from '@mui/material';
import { isEmail } from '../../helpers';
import { UfficioMap } from './UfficioMap';
import { ResearchContext } from '../pages/research/ResearchContext';

export const UfficioMappaContainer = ({ title, subtitle, ufficiListVisibilityDefault, filtriUfficiVisibilityDefault, hideBntUfficiList, isWidgetMap, ufficiList = [], altriUfficiList = [], filtriTipiUffici = [], filtriTipiUfficiEnabled, setFiltriTipiUfficiEnabled, isLoadingUffici, isLoadingAltriUffici, currentUserLocation, handleUfficioMarkerClick, activeSearchType, handleCodeClick, isFiltriUfficiVisible, noResultTitle, filterTipiUffici }) => {
    const [ufficiListVisibility, setUfficiListVisibility] = useState(ufficiListVisibilityDefault);
    const [filtriUfficiVisibility, setFiltriUfficiVisibility] = useState(filtriUfficiVisibilityDefault ?? false);
    const [ufficiDetailVisibility, setUfficiDetailVisibility] = useState([]);

    const mapRef = useRef(null);
    const markerRefs = useRef([]);

    const theme = useTheme();
    const lessThanMediumBreakpoint = useMediaQuery(theme.breakpoints.down("md"));

    const {
        state,
    } = useContext(ResearchContext);

    const {
        province
    } = state;

    const handleUfficioClick = (ufficio) => {
        if (ufficio.latitudine && ufficio.longitudine)
            mapRef.current.flyTo(
                [ufficio.latitudine, ufficio.longitudine],
                18,
                { duration: 0.7 }
            );
        setTimeout(
            function () {
                markerRefs.current[ufficio.id]?.openPopup();
            }, 1000);

    }

    const handleCenterMapClick = () => {
        mapRef.current.flyTo(
            [42, 12.5],
            5,
            { duration: 0.7 }
        );
    }

    const getAllTipiUfficiTreeIds = (tipiUffici, padreId = null) => {
        var tipiUfficiIds = tipiUffici.filter(x => x.padreId === padreId)?.map(x => x.id);
        if (tipiUfficiIds && tipiUfficiIds.length > 0) {
            var tempTipiUfficiIds = [];
            tipiUfficiIds.forEach(x => tempTipiUfficiIds = [...tempTipiUfficiIds, ...getAllTipiUfficiTreeIds(tipiUffici, x)]);
        }
        if (tempTipiUfficiIds?.length > 0)
            tipiUfficiIds = [...tipiUfficiIds, ...tempTipiUfficiIds]
        return tipiUfficiIds;
    }

    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    const renderTipiUfficiList = (tipiUffici, padreId = null) => {
        tipiUffici = tipiUffici?.sort((a, b) => a.ordine > b.ordine);
        return tipiUffici
            ?.filter(x => x.padreId === padreId).map(tipoUfficio => {
                return <TreeItem
                    key={tipoUfficio.id}
                    nodeId={`${tipoUfficio.id}`}
                    label={
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                {
                                    tipoUfficio.urlIcona ?
                                        <img alt="icona" width={24} src={tipoUfficio.urlIcona} />
                                        :
                                        <RoomIcon />
                                }
                                <Typography fontSize={14} marginLeft={1}>
                                    {tipoUfficio.nome}
                                </Typography>
                            </Box>
                            <Checkbox
                                checked={filtriTipiUfficiEnabled.some(x => x === tipoUfficio.id)}
                                onClick={e => {
                                    e.stopPropagation();
                                    if (e.target.checked) {
                                        let temp = [...filtriTipiUfficiEnabled, ...getAllTipiUfficiTreeIds(filtriTipiUffici, tipoUfficio.id), tipoUfficio.id];
                                        temp = temp.filter(onlyUnique);
                                        setFiltriTipiUfficiEnabled(temp);
                                    }
                                    else {
                                        let temp = [...getAllTipiUfficiTreeIds(filtriTipiUffici, tipoUfficio.id), tipoUfficio.id];
                                        temp = temp.filter(onlyUnique);
                                        setFiltriTipiUfficiEnabled(filtriTipiUfficiEnabled.filter(x => !temp.some(y => y === x)));
                                    }
                                }}
                                sx={{ marginRight: 1, padding: 0.5 }}
                            />
                        </Box>
                    } >
                    {tipiUffici.some(x => x.padreId === tipoUfficio.id) ? renderTipiUfficiList(tipiUffici, tipoUfficio.id) : null}
                </TreeItem>
            })
    }

    const renderContattiList = (contatti, even = true, padreId = null, soloScheda = false) => {
        return contatti.filter(x => x.padreId === padreId).sort((a, b) => a.ordine - b.ordine).map(contatto => {
            let hasChildren = contatti.filter(x => x.padreId === contatto.id).length > 0;
            if (hasChildren && renderContattiList(contatti, true, contatto.id, soloScheda)?.every(x => x === null))
                return null;
            if (hasChildren && renderContattiList(contatti, true, contatto.id, soloScheda)?.every(x => x === null))
                return null;
            if (!hasChildren && !contatto.valore)
                return null;
            if (soloScheda && contatto.tipoContattoId !== 9)
                return null;
            if (hasChildren) {
                return <Grid item container xs={12}>
                    <Grid item xs={12}>
                        <Typography fontSize={12} fontWeight="bold" marginTop={1}>
                            {contatto.descrizione?.toLowerCase()}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} marginLeft={3} sx={{
                        width: "100%", marginY: 0.5, padding: 0.5, backgroundColor: even ? 'white' : '#0059b314'
                    }}>
                        {
                            renderContattiList(contatti, !even, contatto.id, soloScheda)
                        }
                    </Grid>
                </Grid>
            } else {
                return <Grid item container xs={12} key={contatto.id}>
                    <Grid item xs={2}>
                        <Typography fontSize={12}>
                            {contatto.descrizione?.toLowerCase()}
                        </Typography>
                    </Grid>
                    <Grid item xs={10}>
                        {
                            contatto.testoCollegamento ?
                                <Typography fontSize={12} fontStyle={contatto.testoCorsivo ? "italic" : null} fontWeight={contatto.testoGrassetto ? "bold" : null} sx={{ wordBreak: "break-word", whiteSpace: "pre-line" }}>
                                    <Link href={isEmail(contatto.linkCollegamento) ? `mailto:${contatto.linkCollegamento}` : `//${contatto.linkCollegamento}`} target="_blank">
                                        {contatto.valore}
                                    </Link>
                                </Typography>
                                :
                                <Typography fontSize={12} fontStyle={contatto.testoCorsivo ? "italic" : null} fontWeight={contatto.testoGrassetto ? "bold" : null} sx={{ wordBreak: "break-word", whiteSpace: "pre-line" }}>
                                    {contatto.valore}
                                </Typography>
                        }
                    </Grid>
                </Grid>
            }
        })
    }

    const getUfficiCountLabel = () => {
        var ufficiCount = ufficiList.length;
        var altriUfficiCount = altriUfficiList.length;
        var totalUfficiCount = ufficiCount + altriUfficiCount;

        var ufficiFilteredCount = ufficiList.filter(x => filtriTipiUfficiEnabled.some(y => y === x.tipoUfficioId)).length;
        var altriUfficiFilteredCount = altriUfficiList.filter(x => filtriTipiUfficiEnabled.some(y => y === x.tipoUfficioId)).length;

        var totalUfficiFilteredCount = ufficiFilteredCount + altriUfficiFilteredCount;


        return `Visualizzati ${totalUfficiFilteredCount} uffici di ${totalUfficiCount}`;
    }

    const getComuneName = (ufficio) => {
        var comuneNameArray = [];

        if (ufficio.comune?.cap)
            comuneNameArray.push(ufficio?.cap);
        if (ufficio.comune?.denominazioneIt)
            comuneNameArray.push(ufficio.comune?.denominazioneIt);

        if (ufficio.comune?.provinciaId) {
            var sigla = province.find(x => x.id === ufficio.comune?.provinciaId)?.sigla;
        }

        return `${comuneNameArray.join(' - ')}${sigla ? ` (${sigla})` : ''}`;
    }

    const listaIdTipoUfficiSchedaSintetica = [30, 26, 3, 2]

    const renderUfficioItem = (ufficio) => {
        return <Grid item xs={12} container alignItems='center' marginBottom={0} key={`ufficio-${ufficio.id}`}>
            {
                !ufficio.id &&
                <Grid item xs={12} sx={{ display: "flex" }} marginY={.75} paddingLeft={1}>
                    <IndeterminateCheckBoxIcon color='error' />
                    <Typography marginLeft={1} sx={{ color: "#d32f2f" }}>
                        {ufficio.messaggioCompetenza}
                    </Typography>
                </Grid>
            }
            {
                ufficio.id !== 0 &&
                <Grid item xs='auto'>
                    <IconButton onClick={e => {
                        if (ufficiDetailVisibility.some(x => x === ufficio.id))
                            setUfficiDetailVisibility(ufficiDetailVisibility.filter(x => x !== ufficio.id));
                        else
                            setUfficiDetailVisibility([...ufficiDetailVisibility, ufficio.id]);
                    }}>
                        {
                            ufficiDetailVisibility.some(x => x === ufficio.id) ?
                                <IndeterminateCheckBoxIcon color={ufficio.eccezioni.length > 0 ? 'warning' : 'primary'} />
                                :
                                <AddBoxIcon color={ufficio.eccezioni.length > 0 ? 'warning' : 'primary'} />
                        }
                    </IconButton>
                </Grid>
            }
            {
                ufficio.id !== 0 &&
                <Grid item xs sx={{ display: "flex", alignItems: "center" }}>
                    <Typography onClick={() => handleUfficioClick(ufficio)} sx={{ cursor: "pointer" }}>
                        {ufficio.nome}
                    </Typography>
                </Grid>

            }
            {
                ufficio.id !== 0 &&
                <Grid item xs={12}>
                    <Collapse in={ufficiDetailVisibility.some(x => x === ufficio.id)} sx={{ color: 'white' }}>
                        <Paper sx={{
                            marginX: 2, backgroundColor: '#0059b314',
                            position: "relative",
                        }} elevation={0}>
                            <Grid container padding={2}>
                                {
                                    ufficio.sottotitolo?.length > 0 &&
                                    <Grid item xs={12}>
                                        <Typography fontSize={12} fontWeight={700}>
                                            {ufficio.sottotitolo}
                                        </Typography>
                                    </Grid>
                                }
                                {
                                    ufficio.msg?.length > 0 &&
                                    <Grid item xs={2}>
                                        <Typography fontSize={12} fontWeight={700}>
                                            comunicazioni di servizio
                                        </Typography>
                                    </Grid>
                                }
                                {
                                    ufficio.msg?.length > 0 &&
                                    <Grid item xs={10}>
                                        <Typography fontSize={12} color={"red"}>
                                            {ufficio.msg}
                                        </Typography>
                                    </Grid>
                                }
                                <Grid item xs={2}>
                                    <Typography fontSize={12}>
                                        comune
                                    </Typography>
                                </Grid>
                                <Grid item xs={10}>
                                    <Typography fontSize={12}>
                                        {getComuneName(ufficio)}
                                    </Typography>
                                </Grid>
                                {
                                    !listaIdTipoUfficiSchedaSintetica.includes(ufficio.tipoUfficioId) && ufficio.indirizzo && ufficio.indirizzo.length > 0 &&
                                    <Grid item xs={2}>
                                        <Typography fontSize={12}>
                                            indirizzo
                                        </Typography>
                                    </Grid>
                                }
                                {
                                    !listaIdTipoUfficiSchedaSintetica.includes(ufficio.tipoUfficioId) && ufficio.indirizzo && ufficio.indirizzo.length > 0 &&
                                    <Grid item xs={10} >
                                        <Typography fontSize={12}>
                                            {ufficio.indirizzo}
                                        </Typography>
                                    </Grid>
                                }
                                {/* {
                                    ufficio.cap && ufficio.cap.length > 0 &&
                                    <Grid item xs={4}>
                                        <Typography fontSize={12}>
                                            cap
                                        </Typography>
                                    </Grid>
                                }
                                {
                                    ufficio.cap && ufficio.cap.length > 0 &&
                                    <Grid item xs={8}>
                                        <Typography fontSize={12}>
                                            {ufficio.cap}
                                        </Typography>
                                    </Grid>
                                } */}
                                {/* {
                                    renderContattiList(ufficio.contatti, true, null, listaIdTipoUfficiSchedaSintetica.includes(ufficio.tipoUfficioId))
                                } */}
                                {
                                    !listaIdTipoUfficiSchedaSintetica.includes(ufficio.tipoUfficioId) && ufficio.altreSedi && ufficio.altreSedi.length > 0 &&
                                    <Grid item xs={2}>
                                        <Typography fontSize={12}>
                                            altre sedi
                                        </Typography>
                                    </Grid>
                                }
                                {
                                    !listaIdTipoUfficiSchedaSintetica.includes(ufficio.tipoUfficioId) && ufficio.altreSedi && ufficio.altreSedi.length > 0 &&
                                    <Grid item xs={10}>
                                        <Typography fontSize={12}>
                                            {ufficio.altreSedi}
                                        </Typography>
                                    </Grid>
                                }
                                {
                                    !listaIdTipoUfficiSchedaSintetica.includes(ufficio.tipoUfficioId) && ufficio.infoAggiuntive && ufficio.infoAggiuntive.length > 0 &&
                                    <Grid item xs={2}>
                                        <Typography fontSize={12}>
                                            informazioni
                                        </Typography>
                                    </Grid>
                                }
                                {
                                    !listaIdTipoUfficiSchedaSintetica.includes(ufficio.tipoUfficioId) && ufficio.infoAggiuntive && ufficio.infoAggiuntive.length > 0 &&
                                    <Grid item xs={10}>
                                        <Typography fontSize={12}>
                                            {ufficio.infoAggiuntive}
                                        </Typography>
                                    </Grid>
                                }
                                {
                                    !listaIdTipoUfficiSchedaSintetica.includes(ufficio.tipoUfficioId) && ufficio.patrono && ufficio.patrono.length > 0 &&
                                    <Grid item xs={2}>
                                        <Typography fontSize={12}>
                                            festività locale
                                        </Typography>
                                    </Grid>
                                }
                                {
                                    !listaIdTipoUfficiSchedaSintetica.includes(ufficio.tipoUfficioId) && ufficio.patrono && ufficio.patrono.length > 0 &&
                                    <Grid item xs={10}>
                                        <Typography fontSize={12}>
                                            {ufficio.patrono}
                                        </Typography>
                                    </Grid>
                                }
                                {
                                    renderContattiList(ufficio.contatti, true, null, listaIdTipoUfficiSchedaSintetica.includes(ufficio.tipoUfficioId))
                                }
                                {
                                    ufficio.dataAggiornamento && ufficio.dataAggiornamento.length > 0 &&
                                    <Grid item xs={2}>
                                        <Typography fontSize={12}>
                                            data aggiornamento
                                        </Typography>
                                    </Grid>
                                }
                                {
                                    ufficio.dataAggiornamento && ufficio.dataAggiornamento.length > 0 &&
                                    <Grid item xs={10}>
                                        <Typography fontSize={12}>
                                            {(new Date(ufficio.dataAggiornamento)).getDate()}
                                            &nbsp;
                                            {(new Date(ufficio.dataAggiornamento)).toLocaleString('default', { month: 'long' })}
                                            &nbsp;
                                            {(new Date(ufficio.dataAggiornamento)).getFullYear()}
                                        </Typography>
                                    </Grid>
                                }
                                {
                                    ufficio.eccezioni && ufficio.eccezioni.map(eccezione => renderEccezioneItem(eccezione))
                                }
                            </Grid>
                        </Paper>
                    </Collapse>
                </Grid>
            }
        </Grid>
    }

    const renderEccezioneItem = (eccezione) => {
        return <Grid item container xs={12} key={`eccezione-${eccezione.id}`}>
            <Grid item xs sx={{ display: "flex", alignItems: "center" }}>
                <Typography fontSize={14} fontWeight="bold" marginTop={1} onClick={() => handleUfficioClick(eccezione)} sx={{ color: "#ed6c02", cursor: "pointer" }}>
                    {eccezione.nome}
                </Typography>
            </Grid>
            <Grid item container padding={2} sx={{ marginY: 0.5, backgroundColor: 'white' }}>
                {
                    eccezione.msg?.length > 0 &&
                    <Grid item xs={4}>
                        <Typography fontSize={12} fontWeight={700}>
                            comunicazioni di servizio
                        </Typography>
                    </Grid>
                }
                {
                    eccezione.msg?.length > 0 &&
                    <Grid item xs={8}>
                        <Typography fontSize={12} color={"red"}>
                            {eccezione.msg}
                        </Typography>
                    </Grid>
                }
                <Grid item xs={4}>
                    <Typography fontSize={12}>
                        comune
                    </Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography fontSize={12}>
                        {eccezione.comune?.denominazioneIt}
                    </Typography>
                </Grid>
                {
                    eccezione.indirizzo && eccezione.indirizzo.length > 0 &&
                    <Grid item xs={4}>
                        <Typography fontSize={12}>
                            indirizzo
                        </Typography>
                    </Grid>
                }
                {
                    eccezione.indirizzo && eccezione.indirizzo.length > 0 &&
                    <Grid item xs={8} >
                        <Typography fontSize={12}>
                            {eccezione.indirizzo}
                        </Typography>
                    </Grid>
                }
                {
                    eccezione.cap && eccezione.cap.length > 0 &&
                    <Grid item xs={4}>
                        <Typography fontSize={12}>
                            cap
                        </Typography>
                    </Grid>
                }
                {
                    eccezione.cap && eccezione.cap.length > 0 &&
                    <Grid item xs={8}>
                        <Typography fontSize={12}>
                            {eccezione.cap}
                        </Typography>
                    </Grid>
                }
                {
                    renderContattiList(eccezione.contatti, false)
                }
                {
                    eccezione.altreSedi && eccezione.altreSedi.length > 0 &&
                    <Grid item xs={4}>
                        <Typography fontSize={12}>
                            altre sedi
                        </Typography>
                    </Grid>
                }
                {
                    eccezione.altreSedi && eccezione.altreSedi.length > 0 &&
                    <Grid item xs={8}>
                        <Typography fontSize={12}>
                            {eccezione.altreSedi}
                        </Typography>
                    </Grid>
                }
                {
                    eccezione.infoAggiuntive && eccezione.infoAggiuntive.length > 0 &&
                    <Grid item xs={4}>
                        <Typography fontSize={12}>
                            informazioni
                        </Typography>
                    </Grid>
                }
                {
                    eccezione.infoAggiuntive && eccezione.infoAggiuntive.length > 0 &&
                    <Grid item xs={8}>
                        <Typography fontSize={12}>
                            {eccezione.infoAggiuntive}
                        </Typography>
                    </Grid>
                }
                {
                    eccezione.patrono && eccezione.patrono.length > 0 &&
                    <Grid item xs={4}>
                        <Typography fontSize={12}>
                            festività locale
                        </Typography>
                    </Grid>
                }
                {
                    eccezione.patrono && eccezione.patrono.length > 0 &&
                    <Grid item xs={8}>
                        <Typography fontSize={12}>
                            {eccezione.patrono}
                        </Typography>
                    </Grid>
                }
                {
                    eccezione.dataAffidabilita && eccezione.dataAffidabilita.length > 0 &&
                    <Grid item xs={4}>
                        <Typography fontSize={12}>
                            data aggiornamento
                        </Typography>
                    </Grid>
                }
                {
                    eccezione.dataAggiornamento && eccezione.dataAggiornamento.length > 0 &&
                    <Grid item xs={8}>
                        <Typography fontSize={12}>
                            {(new Date(eccezione.dataAffidabilita)).getDate()}
                            &nbsp;
                            {(new Date(eccezione.dataAffidabilita)).toLocaleString('default', { month: 'long' })}
                            &nbsp;
                            {(new Date(eccezione.dataAffidabilita)).getFullYear()}
                        </Typography>
                    </Grid>
                }
            </Grid>
        </Grid>
    }

    useEffect(() => {
        if (mapRef.current)
            mapRef.current.invalidateSize();
    }, [ufficiListVisibility, lessThanMediumBreakpoint]);


    useEffect(() => {
        if (mapRef.current && isWidgetMap) {
            mapRef.current.invalidateSize();
        }
        if (mapRef.current) {
            mapRef.current.flyTo(
                [42, 12.5],
                5,
                { duration: 1 }
            );
        }

        if (ufficiList && ufficiList.length === 1) {
            setUfficiDetailVisibility([...ufficiDetailVisibility, ufficiList[0].id]);
        }
    }, [ufficiList]);

    return (
        <>
            {
                (isLoadingUffici || isLoadingAltriUffici) &&
                <LinearProgress sx={{ width: "100%" }} />
            }
            <div style={{ display: 'flex', width: '100%', height: '100%' }}>
                <div style={{ position: 'relative', display: 'flex', minHeight: "100%", minWidth: !isWidgetMap && lessThanMediumBreakpoint ? '100%' : (ufficiListVisibility ? '40%' : '100%'), maxWidth: ufficiListVisibility ? '40%' : '100%' }}>
                    <UfficioMap
                        onUfficioMarkerClick={ufficiIds => {
                            setUfficiDetailVisibility(ufficiIds);
                        }}
                        currentUserLocation={currentUserLocation}
                        ufficiData={
                            [
                                ...ufficiList.filter(x => filtriTipiUfficiEnabled.some(y => y === x.tipoUfficioId)).filter(x => x.latitudine && x.longitudine),
                                ...altriUfficiList.filter(x => filtriTipiUfficiEnabled.some(y => y === x.tipoUfficioId)).filter(x => x.latitudine && x.longitudine),
                                ...ufficiList.filter(x => filtriTipiUfficiEnabled.some(y => y === x.tipoUfficioId)).map(x => x.eccezioni).flat().filter(x => x.latitudine && x.longitudine),
                                ...altriUfficiList.filter(x => filtriTipiUfficiEnabled.some(y => y === x.tipoUfficioId)).map(x => x.eccezioni).flat().filter(x => x.latitudine && x.longitudine),
                            ]
                        }
                        mapRef={mapRef}
                        markerRefs={markerRefs}
                        style={{ minWidth: '100%', maxWidth: '100%' }}
                        initialZoom={5} />
                    <Hidden mdDown={!isWidgetMap}>
                        <Button
                            disableElevation
                            onClick={e => {
                                e.stopPropagation();
                                if (setUfficiListVisibility)
                                    setUfficiListVisibility(!ufficiListVisibility);
                            }}
                            sx={{
                                visibility: (hideBntUfficiList) ? 'hidden' : 'visible',
                                borderRadius: 0,
                                height: "100%",
                                padding: 0,
                                minWidth: '20px',
                                maxWidth: '20px',
                                transition: "all 0.2s linear",
                                marginLeft: '-20px',
                                zIndex: 999,
                            }}>
                            {
                                ufficiListVisibility ?
                                    <ArrowRight color='primary.main' sx={{ fontSize: 40 }} />
                                    :
                                    <ArrowLeft color='primary.main' sx={{ fontSize: 40 }} />
                            }
                        </Button>
                    </Hidden>
                    <Tooltip title="Centra mappa">
                        <Button
                            variant='contained'
                            onClick={e => handleCenterMapClick()}
                            sx={{
                                position: 'absolute',
                                left: '10px',
                                top: '80px',
                                minWidth: '34px',
                                maxWidth: '34px',
                                height: '34px',
                                zIndex: 999,
                            }}>
                            <CenterFocusStrongIcon />
                        </Button>
                    </Tooltip>
                    {
                        isFiltriUfficiVisible &&
                        <Tooltip title="Ambiti e tipi ufficio">
                            <Button
                                variant='contained'
                                onClick={e => setFiltriUfficiVisibility(!filtriUfficiVisibility)}
                                sx={{
                                    position: 'absolute',
                                    left: '10px',
                                    top: '120px',
                                    minWidth: '34px',
                                    maxWidth: '34px',
                                    height: '34px',
                                    zIndex: 999,
                                }}>
                                <BusinessIcon />
                            </Button>
                        </Tooltip>
                    }
                    <Grow in={isFiltriUfficiVisible ? filtriUfficiVisibility : false} >
                        <Paper
                            sx={{
                                position: 'absolute',
                                left: '60px',
                                top: '10px',
                                maxWidth: '460px',
                                width: '80%',
                                maxHeight: '500px',
                                zIndex: 999,
                                transition: "all 0.2s linear",
                                backgroundColor: 'rgba(255, 255, 255, 0.8)',
                                overflowY: 'auto'
                            }}>
                            <TreeView
                                sx={{ paddingRight: '16px', }}
                                defaultCollapseIcon={<ArrowDropDown />}
                                defaultExpandIcon={<ArrowRight />}>
                                {
                                    renderTipiUfficiList(filterTipiUffici)
                                }
                            </TreeView>
                        </Paper>
                    </Grow>
                </div>
                <Hidden mdDown={!isWidgetMap}>
                    <div style={{ minHeight: "100%", display: ufficiListVisibility ? 'block' : 'none', minWidth: ufficiListVisibility ? '60%' : '0%', maxWidth: ufficiListVisibility ? '60%' : '0%' }}>
                        <Grid container direction='column' alignItems='flex-start' height='100%'>
                            {!noResultTitle && <Grid item xs='auto' paddingY={1} minWidth='100%' sx={{ backgroundColor: 'primary.main' }}>
                                <Typography align="center" sx={{ color: 'white' }}>
                                    {
                                        title ?
                                            title
                                            :
                                            "Effettua una ricerca per visualizzare i risultati"
                                    }
                                </Typography>
                            </Grid>}
                            {!noResultTitle && <Grid item xs='auto' container minWidth='100%'>
                                <Grid item xs={altriUfficiList && altriUfficiList.length > 0 ? 6 : 12} sx={{ backgroundColor: "rgba(0, 89, 179, 0.08)", color: "rgba(0, 0, 0, 0.6)", padding: 2, display: "flex", alignItems: "center" }}>
                                    <Typography align="center" variant="caption" sx={{ width: "100%" }}>
                                        {
                                            subtitle ?
                                                subtitle
                                                :
                                                null
                                        }
                                    </Typography>
                                </Grid>
                                {
                                    altriUfficiList && altriUfficiList.length > 0 &&
                                    <Grid item xs={6} sx={{ backgroundColor: "rgba(0, 89, 179, 0.08)", color: "rgba(0, 0, 0, 0.6)", padding: 2, display: "flex", alignItems: "center" }}>
                                        <Typography align="center" variant="caption" sx={{ width: "100%" }}>
                                            ISTITUTI PENITENZIARI, STRUTTURE MINORILI E ALTRI UFFICI
                                        </Typography>
                                    </Grid>
                                }
                            </Grid>}
                            {(!isLoadingUffici && (altriUfficiList.length > 0 || ufficiList.length > 0)) && <Typography

                                variant="caption"
                                sx={{
                                    marginTop: '4px',
                                    marginLeft: '8px',
                                    width: "100%"
                                }}>
                                {
                                    getUfficiCountLabel()
                                }
                            </Typography>}

                            <Grid item xs container alignItems='flex-start' sx={{ overflowY: "auto" }}>
                                <Grid item xs={isLoadingAltriUffici || (altriUfficiList && altriUfficiList.length > 0) ? 6 : 12} padding={1} container alignItems='flex-start' alignContent='flex-start' minHeight={isLoadingUffici || ufficiList.length > 0 ? '100%' : null} borderRight={altriUfficiList && altriUfficiList.length > 0 ? 0.3 : 0}>
                                    {
                                        isLoadingUffici ?
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                                                <CircularProgress />
                                            </div>
                                            :
                                            ufficiList.filter(x => filtriTipiUfficiEnabled.some(y => y === x.tipoUfficioId) || !x.id).map(ufficio =>
                                                renderUfficioItem(ufficio)
                                            )
                                    }
                                </Grid>
                                <Grid item xs={6} padding={1} container alignItems='flex-start' alignContent='flex-start' minHeight={isLoadingAltriUffici || altriUfficiList?.length > 0 ? '100%' : null} >
                                    {
                                        isLoadingAltriUffici ?
                                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                                                <CircularProgress />
                                            </div>
                                            :
                                            altriUfficiList.filter(x => filtriTipiUfficiEnabled.some(y => y === x.tipoUfficioId)).map(ufficio =>
                                                renderUfficioItem(ufficio)
                                            )
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </Hidden>
            </div >
            <Hidden mdUp mdDown={isWidgetMap}>
                {
                    ufficiList?.length > 0 &&
                    <Grid container direction='column' alignItems='flex-start'>
                        <Grid item xs='auto' paddingY={1} minWidth='100%' sx={{ backgroundColor: 'primary.main' }}>
                            <Typography align="center" sx={{ color: 'white' }}>
                                {
                                    title ?
                                        title
                                        :
                                        "RISULTATI DELLA RICERCA"
                                }
                            </Typography>
                        </Grid>
                        {!noResultTitle && subtitle && <Grid item xs='auto' container minWidth='100%'>
                            <Grid item xs={12} sx={{ backgroundColor: "rgba(0, 89, 179, 0.08)", color: "rgba(0, 0, 0, 0.6)", padding: 2, display: "flex", alignItems: "center" }}>
                                <Typography align="center" variant="caption" sx={{ width: "100%" }}>
                                    {
                                        subtitle ?
                                            subtitle
                                            :
                                            "UFFICI"
                                    }
                                </Typography>
                            </Grid>
                        </Grid>}
                        {(!isLoadingUffici && (altriUfficiList.length > 0 || ufficiList.length > 0)) && <Typography

                            variant="caption"
                            sx={{
                                marginTop: '4px',
                                marginLeft: '8px',
                                width: "100%"
                            }}>
                            {
                                getUfficiCountLabel()
                            }
                        </Typography>}

                        <Grid item xs={12} padding={1} container alignItems='flex-start' alignContent='flex-start' minHeight='100%'>
                            {
                                isLoadingUffici ?
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                                        <CircularProgress />
                                    </div>
                                    :
                                    ufficiList.filter(x => filtriTipiUfficiEnabled.some(y => y === x.tipoUfficioId) || !x.id).map(ufficio =>
                                        renderUfficioItem(ufficio)
                                    )
                            }
                        </Grid>

                        {
                            altriUfficiList && altriUfficiList.length > 0 &&
                            <Grid item xs={12} sx={{ backgroundColor: "rgba(0, 89, 179, 0.08)", color: "rgba(0, 0, 0, 0.6)", padding: 2, display: "flex", alignItems: "center", width: "100%" }}>
                                <Typography align="center" variant="caption" sx={{ width: "100%" }}>
                                    ISTITUTI PENITENZIARI, STRUTTURE MINORILI E ALTRI UFFICI
                                </Typography>
                            </Grid>
                        }
                        <Grid item xs={12} padding={1} container alignItems='flex-start' alignContent='flex-start' minHeight={altriUfficiList?.length > 0 ? '100%' : null} >
                            {
                                isLoadingAltriUffici ?
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "100%" }}>
                                        <CircularProgress />
                                    </div>
                                    :
                                    altriUfficiList.filter(x => filtriTipiUfficiEnabled.some(y => y === x.tipoUfficioId)).map(ufficio =>
                                        renderUfficioItem(ufficio)
                                    )
                            }
                        </Grid>
                    </Grid>
                }
            </Hidden>
        </>
    );


}